// noinspection JSIgnoredPromiseFromCall

import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { patchAlertValidation } from '../../services/AlertsService';
import { AlertValidationRequest, AlertDetails } from '../../types/Alerts';

type Result = UseMutationResult<AlertDetails, Error, AlertValidationRequest>;

function usePatchAlertValidation(successCb: (alert: AlertDetails) => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(patchAlertValidation, {
    onSuccess: (alert) => {
      successCb(alert);
      queryClient.invalidateQueries({ queryKey: ['alerts'] });
      queryClient.invalidateQueries({ queryKey: ['alert'] });
      queryClient.invalidateQueries({ queryKey: ['notes'] });
      queryClient.invalidateQueries({ queryKey: ['notes-lazy'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePatchAlertValidation;
